<app-audio-track *ngIf="storyboard" [storyboard]="storyboard"></app-audio-track>
<app-control-bar [storyboard]="storyboard" (newLayerEvent)="swapLayerCreatingMode()"></app-control-bar>

<div class="layers" dnd-sortable-container [sortableData]="storyboard.timeline.layers">
    <app-create-video-layer (acceptEvent)="newLayer($event)" (declineEvent)="swapLayerCreatingMode()" *ngIf="creatingLayer"></app-create-video-layer>
    <app-transcribe-editor *ngIf="storyboard && transcriptionEditing" (onCloseSRTEditor)="closeSRTEditor($event)" [storyboard]="storyboard"></app-transcribe-editor>
    <div (onDropSuccess)="onDropSuccess()" class="app-video-layer" (mouseenter)="mouseEnter($event, layer)" (deleteLayerEvent)="deleteLayer($event)" (onOpenSRTEditor)="openSRTEditor($event)" [layer]="layer" *ngFor="let layer of storyboard.timeline.layers; let i = index" [storyboard]="storyboard" dnd-sortable [sortableIndex]="i" [dragEnabled]="!storyboard.read_only"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/timeline.component.html